// ai创作相关接口
import request from '@/utils/http.js';

// 获取概要总结信息
const getSummaryInfo = (params = {}) => {
  let url = '/v3/ai/video/summary-info';

  return request({
    url: url,
    method: 'GET',
    params: params
  });
};


/**
 * 观看端聚合接口
 * 获取内容包括：
 *  智能字幕、字幕样式、精彩时刻、概要总结
 * @param {*} params
 * @returns
 */
const getAiUnionInfo = (params = {}) => {
  let url = '/v3/ai/video/watch-union';
  return request({
    url: url,
    method: 'GET',
    params: params
  });
};
/**
 * AI直播纪要-总结列表查询
 * 接口ID：332744430
 * 接口地址：https://app.apifox.com/link/project/6028826/apis/api-332744430
 *
 */
const getSummaryList = (params = {}) => {
  let url = "/v3/ai/live/summary/list"
  return request({
    url: url,
    method: 'POST',
    data: params,
    headers: {
      'Content-Type': 'application/json'
    }
  });
}
//获取逐字稿列表
const getAsrList = (params = {}) => {
  let url = "/v3/ai/live/asr/list"
  return request({
    url: url,
    method: 'POST',
    data: params,
    headers: {
      'Content-Type': 'application/json'
    }
  });
}

//获取逐字稿和总结列表
const getAsrSummaryList = (params = {}) => {
  let url = "/v3/ai/live/latest/asr-summary"
  return request({
    url: url,
    method: 'POST',
    data: params,
    headers: {
      'Content-Type': 'application/json'
    }
  });
}

// 直播中AI问答
const sendAiqaAsk = (params = {}) => {
  let url = "/v3/ai/live/qa/ask"
  return request({
    url: url,
    method: 'POST',
    data: params,
    headers: {
      'Content-Type': 'application/json'
    }
  });
}
const reqAiqaHistory = (params = {}) => {
  let url = "/v3/ai/live/qa/ask/history"
  return request({
    url: url,
    method: 'POST',
    data: params,
    headers: {
      'Content-Type': 'application/json'
    }
  });
}

const aiApi = {
  getSummaryInfo,
  getAiUnionInfo,
  getSummaryList,
  getAsrList,
  getAsrSummaryList,
  sendAiqaAsk,
  reqAiqaHistory
};


export default aiApi;
